<template>
  <div class="popups-list">
    <div class="grid" :class="{
      'grid-skeleton': loading,
      'grid-three-or-more': popups.length >= 3,
      'grid-less-than-three': popups.length > 0 && popups.length < 3
    }">
      <div v-if="loading">
        <PopupCardSkeleton v-for="n in 10" :key="n" />
      </div>
      <draggable v-else-if="popups.length" v-model="popups" v-bind="dragOptions" @start="drag = true"
        @end="sortPopups()" tag="div">
        <transition-group>
          <PopupCard v-for="popup in popups"
          :key="popup.id"
          :popupInfo="popup"
          :editPermission="editPermission"
          :languages="languages"
          :displays="displays"
          @openFullInfo="openPopupModal(popup)"
          @openEdit="openPopupPage(popup.context.id)" />
        </transition-group>
      </draggable>
      <EmptyState v-else :text="emptyStateText" :isAddDisabled="false" textBtn="Add" @add="createPopup" />
    </div>
    <a-modal v-model="isPopupModalOpen" :footer="null" width="1100px" :destroyOnClose="true">
      <template #title>
        <div>
          <span style="display: block;">
            Popup info
          </span>
          <span class="modal-uuid">
            UUID: {{ popupUUID }}
          </span>
        </div>
      </template>
      <PopupInfoModal :popupInfo="popupObject" :languages="languages"  :displays="displays" @close="closePopupModal" />
    </a-modal>
  </div>
</template>
<script>
import PopupCard from '@/views/apps/media/components/popups/popupCard.vue'
import PopupCardSkeleton from '@/views/apps/media/components/popups/popupCardSkeleton.vue'
import PopupInfoModal from '@/views/apps/media/components/popups/popupInfoModal.vue'
import EmptyState from '@/components/custom/emptyState.vue'

import MediaService from '@/services/api/apiMediaService'
// import ViewscreenService from '@/services/api/apiViewscreenService'
import { routerPushWithFilters } from '@/services/utils/routerHelpers'

import draggable from 'vuedraggable'
export default {
  name: 'Popups-list',
  components: {
    draggable,
    PopupCard,
    PopupCardSkeleton,
    PopupInfoModal,
    EmptyState,
  },
  props: {
    editPermission: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
    },
    filters: {
      type: Object,
    },
    displays: {
      type: Object,
    },
    filtersReady: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popups: [],
      drag: false,
      loading: false,
      apps: undefined,
      isPopupModalOpen: false,
      popupObject: undefined,
    }
  },
  computed: {
    popupUUID() {
      return this.popupObject ? this.popupObject.context.uuid : ''
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
    emptyStateText() {
      return this.filters.name?.length ? 'Oops! Nothing matches your search.' : 'Add first popup-banner'
    },
    filtersToBeWatched() {
      return Object.assign({}, this.filters)
    },
  },
  async created() {
    await this.listUpdate()
  },
  watch: {
    filtersToBeWatched: {
      handler(newVal, oldVal) {
        if (!this.filtersReady) return

        if (!newVal.search && !oldVal.search && newVal.selectedSearch !== oldVal.selectedSearch) {
          return
        }

        this.listUpdate()
      },
      deep: true,
    },
  },
  methods: {
    openPopupPage(id) {
      routerPushWithFilters(this.$router, `/media/popup-banners/edit/${id}`)
    },
    redirectToMain() {
      this.$router.push(`/main/${this.$route.params.viewscreenId}`)
    },
    createPopup() {
      routerPushWithFilters(this.$router, '/media/popup-banners/create')
    },
    openPopupModal(popupObject) {
      this.popupObject = popupObject
      this.isPopupModalOpen = true
    },
    closePopupModal() {
      this.isPopupModalOpen = false
    },
    async listUpdate() {
      try {
        this.loading = true
        await this.getPopups()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async getPopups() {
      const { search, active, localizationId, applicationId, selectedSearch } = this.filters
      const searchParams = new URLSearchParams()
      searchParams.append('active', active ? '1' : '0')

      if (typeof localizationId !== 'undefined') {
        searchParams.append('lang_id', localizationId)
      }

      if (typeof applicationId !== 'undefined') {
        searchParams.append('app_id', applicationId)
      }

      if (search !== undefined) {
        searchParams.append(selectedSearch, search)
      }

      try {
        this.loading = true

        const popupsResponse = await MediaService.getPopups(searchParams)

        if (!popupsResponse?.data?.data) {
          this.$notification.error({
            message: 'Something went wrong. Please try again later.',
          })
        }

        this.popups = popupsResponse.data.data
      } catch (err) {
        let errorMessage = 'Something went wrong. Please try again later.'

        if (err.response?.data?.error?.message) {
          errorMessage = err.response.data.error.message
        } else if (err.message) {
          errorMessage = err.message
        }

        this.$notification.error({
          message: errorMessage,
        })
      } finally {
        this.loading = false
      }
    },

    async sortPopups() {
      const popupsSort = this.popups.map((popup, index, popupsArr) => {
        return {
          id: popup.context.id,
          sort: popupsArr.length - index,
        }
      })
      try {
        await MediaService.sortPopups(this.filters.applicationId, popupsSort)
        this.$notification.success({
          message: 'Sucessfully sorted',
        })
      } catch (error) {
        console.log(error)
      }
      this.drag = false
    },
  },
}
</script>
